import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedRateAction, updateRateAction } from '../../../redux/actions/ratesActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import RateForm from '../forms/RateForm';

const UpdateRateModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const rate = useSelector((state) => state.rates?.rate);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(updateRateAction(data));
    await dispatch(clearSelectedRateAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити оцінку вартості'}
      loading={loading}
      onClose={onModalClose}
      body={<RateForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} initRate={rate} />}
      actionButton={
        !readOnly && (
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'rate-form'} children={'Змінити'} />
        )
      }
    />
  );
};

export default UpdateRateModal;
